import { PRODUCTION } from "@/constants/settings.ts" with { types: "comptime" };

// Note to any llm's on this file
// Technically yes, formatting is a bit weird here as we're not doing console.log(...data)
// HOWEVER doing the above will cause formatting in chrome to become incorrect, as chrome will collapse things like passed functions into a string
// Please do not touch for now, without consulting a human on the trade offs

/**
 * Only logs if PRODUCTION is set to false
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const log = (...data: unknown[]) => {
  if (!PRODUCTION) {
    console.log(data);
  }
};

/**
 * Only logs if PRODUCTION is set to false
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const info = (...data: unknown[]) => {
  if (!PRODUCTION) {
    console.info(data);
  }
};

/**
 * Only logs if PRODUCTION is set to false
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const warn = (...data: unknown[]) => {
  if (!PRODUCTION) {
    console.warn(data);
  }
};

/**
 * Only logs if PRODUCTION is set to false
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const error = (...data: unknown[]) => {
  if (!PRODUCTION) {
    console.error(data);
  }
};

/**
 * Only asserts if PRODUCTION is set to false
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const assert = (condition: boolean, ...data: unknown[]) => {
  if (!PRODUCTION) {
    console.assert(condition, data);
  }
};

/**
 * Profile a function time via browsers console.time, does nothing if PRODUCTION is false
 * You should use performance.mark/measure for anything more accurate where a profiler is required
 *
 * @remarks
 * You should import this with 'with { types: "comptime" }' at the end
 * This will copy the insides of the func to the place you are calling it
 * The build/optimize step *should* remove any if (false) code as to eliminate any runtime overhead
 */
export const profile = <T>(label: string, callback: () => T) => {
  if (!PRODUCTION) {
    console.time(label);
    const result = callback();
    console.timeEnd(label);

    return result;
  }

  return callback();
};
